<template>
  <v-app-bar color="white" elevation="0">
    <v-btn :href="frontendUrl">
      <v-app-bar-title><img :src="inletsLogo" alt="inlets.ai" class="brand-logo-img" /></v-app-bar-title>
    </v-btn>
  </v-app-bar>
  <v-app>
    <v-main>
      <v-container class="fill-height">
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" sm="8" md="6">
            <v-card class="pa-4">
              <v-card-title class="text-left">
                <h3>Confirm your email</h3>
              </v-card-title>
              <v-card-text>
                <v-row v-if="loading" align="center" justify="center" class="py-6">
                  <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                </v-row>
                <template v-else-if="success">
                  <p class="mb-4">{{ successMessage }}</p>
                  <v-btn color="primary" @click="toLogin">Go to Login</v-btn>
                </template>
                <template v-else-if="errorMessage">
                  <v-alert type="error" variant="tonal" class="mb-4">
                    {{ errorMessage }}
                  </v-alert>
                  <v-btn color="primary" variant="outlined" @click="toLogin">Back to Login</v-btn>
                  <v-btn class="ml-2" color="primary" @click="toResend">Resend confirmation</v-btn>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "@/axios.js";
import router from "@/router";
import store from "@/store";
import inletsLogo from "@/assets/images/inlets-logo-color.svg";

const BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  name: "ConfirmEmail",
  data() {
    return {
      inletsLogo,
      loading: true,
      success: false,
      successMessage: "Your email has been confirmed. You can now sign in.",
      errorMessage: null,
    };
  },
  computed: {
    frontendUrl() {
      return process.env.VUE_APP_FRONTEND_URL;
    },
    confirmationToken() {
      return this.$route.query.confirmation_token;
    },
  },
  mounted() {
    if (this.confirmationToken) {
      this.confirmEmail();
    } else {
      this.loading = false;
      this.errorMessage = "Missing confirmation link. Please use the link from your email.";
    }
  },
  methods: {
    async confirmEmail() {
      try {
        const response = await axios.post(`${BASE_URL}/users/confirmation`, {
          confirmation_token: this.confirmationToken,
        });
        this.loading = false;
        this.success = true;
        if (response.data.pending_approval) {
          this.successMessage = response.data.message;
        } else if (response.headers.authorization) {
          store.commit("setUserInfo", response);
          router.push({ name: "Dashboard" });
        }
      } catch (error) {
        this.loading = false;
        this.errorMessage =
          error.response?.data?.message || "Invalid or expired confirmation link. Please request a new one.";
      }
    },
    toLogin() {
      router.push({ name: "Login" });
    },
    toResend() {
      router.push({ name: "ConfirmEmailSent" });
    },
  },
};
</script>
